const REGEX_MESSAGE_SEPARATOR = ":::"

export const getRegexPattern = fieldConfig => {
  if (typeof fieldConfig === "string") {
    const separatorIndex = fieldConfig.indexOf(REGEX_MESSAGE_SEPARATOR)
    if (separatorIndex === -1) {
      return fieldConfig.trim()
    }

    return fieldConfig.slice(0, separatorIndex).trim()
  }

  return ""
}

export const getRegexValidationMessage = fieldConfig => {
  if (typeof fieldConfig === "string") {
    const separatorIndex = fieldConfig.indexOf(REGEX_MESSAGE_SEPARATOR)
    if (separatorIndex === -1) {
      return ""
    }

    return fieldConfig
      .slice(separatorIndex + REGEX_MESSAGE_SEPARATOR.length)
      .trim()
  }

  return ""
}
